<app-modal [open]="open()" [gradientVariant]="gradientVariant()" (close)="onCancel()">
  <!-- Header -->
  <div class="px-6 py-4 border-b border-subtle">
    <h3 class="text-base font-semibold text-primary">{{ title() }}</h3>
  </div>

  <!-- Content -->
  <div class="px-6 py-4">
    <p class="text-sm text-secondary leading-relaxed">{{ message() }}</p>
  </div>

  <!-- Footer -->
  <div class="px-6 py-4 border-t border-subtle flex items-center justify-end gap-3">
    <app-button
      variant="secondary"
      size="md"
      (click)="onCancel()"
    >
      {{ cancelText() }}
    </app-button>
    <app-button
      [variant]="variant()"
      size="md"
      (click)="onConfirm()"
    >
      {{ confirmText() }}
    </app-button>
  </div>
</app-modal>
